import { useMutation } from "@tanstack/react-query";
import { deactivateTripadvisorReviews } from "../../api/bReviewsApi";

export const useDeactivateTripadvisorReviews = () => {
  return useMutation({
    mutationKey: ["deactivate-tripadvisor-reviews"],
    mutationFn: (data) => deactivateTripadvisorReviews(data),
    onError: (error) => {
      console.error("TripAdvisor deactivate error:", error.response || error);
    },
  });
};
